
var header = document.querySelector('.header');
var menuIcon = header.querySelector('.header__menu-button');
var menu = header.querySelector('.header__nav');

if (menu) {
  menuIcon.onclick = function () {
    menuIcon.classList.toggle('header__menu-button--active');
    menu.classList.toggle('header__nav--open');
  };

  window.addEventListener('click', function (event) {
    if (!event.target.closest('.header')) {
      closeMenu();
    }
  });

  window.onresize = function () {
    closeMenu();
  };

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ('key' in evt) {
      isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
    } else {
      isEscape = (evt.keyCode === 27);
    }
    if (isEscape) {
      closeMenu();
    }
  };
}

function closeMenu() {
  menuIcon.classList.remove('header__menu-button--active');
  menu.classList.remove('header__nav--open');
}

// Submenu toggles
$('.header__nav-item.has-submenu').each(function () {
  var $this = $(this);
  var submenuLink = $this.find('.header__nav-link');
  var touchTimeOut = false;

  submenuLink.click(function (e) {
    e.preventDefault();
    if (!touchTimeOut) {
      $this.toggleClass('open');
    }
  });

  // Only do hover if not mobile and not hidden menu
  if ($(window).width() > 900 && $this.parents('.header__nav.default').length) {
    $this.mouseenter(function () {
      $this.addClass('open');

      // Touch events trigger mousenter first, so don't allow click within 400ms
      touchTimeOut = true;
      setTimeout(function () {
        touchTimeOut = false;
      }, 400)
    });

    $this.mouseleave(function () {
      $this.removeClass('open');
    });
  }
});

// Anchor scrolling ------------------------------------------- //
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    closeMenu();
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      var targetID = this.getAttribute('href');
      var headerHeight = $('.header').height();
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        window.history.pushState('', '', targetID);
        $('html, body').animate({
          scrollTop: target.offset().top - headerHeight
        }, 1000);
      }
    }
  });

// Show more button ------------------------------------------- //
$('[data-show-more]').each(function () {
  var $btn = $(this).find('[data-show-more="button"]');
  var $items = $(this).find('[data-show-more="item"]');

  $btn.click(function () {
    $items.slideDown('fast');
    $btn.closest('[data-show-more="container"]').hide();
  });
});

// Terms popup ------------------------------------------- //
$('.wb-popup').magnificPopup({
  type: 'inline',
  mainClass: 'mfp-fade',
});

// Change black text color to #242424
function changeTextColor() {
  const elements = document.querySelectorAll('*');
  elements.forEach(element => {
    const computedColor = window.getComputedStyle(element).color || window.getComputedStyle(element).backgroundColor;
    if (computedColor === 'rgb(0, 0, 0)' || computedColor === '#000000') {
      element.style.color = '#242424';
    }
  });
}

// Run the function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', changeTextColor);

// Run the function again after a short delay to catch any dynamically added content
setTimeout(changeTextColor, 1000);
